<template>
  <div class="nav-bar-container">
    <van-nav-bar
      :title="title"
      :left-text="leftText"
      :border="borderBottom"
      :fixed="true"
      left-arrow
      @click-left="onClickLeft"
    />
  </div>
</template>

<script>
export default {
  name: "DfUi2Navbar",
  props: {
    title: {
      type: String,
      default: "", // 起始值
    },
    leftText: {
      type: String,
      default: "", // 起始值
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickLeft() {
      // 如果 decimals 存在且大于 0，显示指定的小数位；否则显示整数
      history.back();
    },
  },
};
</script>

<style scoped lang="scss">
.nav-bar-container {
  --van-nav-bar-background-color: rgb(3, 11, 59);
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-icon-color: #fff;
}
</style>
